export const NAME = 'banners';
